export default {
    "project": "fa-tasks",
    "contract": "fa-print",
    "device": "fa-tablet",
    "record": "fa-bars",
    "report": "fa-book",
    "stat": "fa-signal",
    "system": "fa-gear",
    "dashboard": "fa-flag",
    "task": "fa-file-text",
}

